import React from 'react';
import ReactDOMClient from 'react-dom/client';
import RundedrehenMapApp from './components/rundedrehen-map-app';

import Viewport from "./components/viewport";
import NavigationMobile from "./components/navigation-mobile";
new Viewport();

// import Slider from "./components/slider";
// import Search from "./components/search";
// import Video from "./components/video";
// import Popup from "./components/popup";
// import Embed from "./components/embed";
// import Up from "./components/up";

import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react'

const matomoInstance = createInstance({
  urlBase: 'https://matomo.rundedrehen.de/',
  siteId: 1,
  disabled: window.location.hostname.includes('lndo.site'),
});


(function (Drupal) {

  Drupal.behaviors.navigationMobile = {
    attach: function (context, settings) {
      new NavigationMobile('.js--navigation-mobile-trigger');
    }
  }


  Drupal.behaviors.rundedrehenMap = {
    attach: function (context, settings) {
      const wrappers = once('rundedrehen-map', '#map-root');
      for (let i = 0; i < wrappers.length; i++) {
        const root = ReactDOMClient.createRoot(wrappers[i]);
        root.render(
          <React.StrictMode>
            <MatomoProvider value={matomoInstance}>
              <RundedrehenMapApp />
            </MatomoProvider>
          </React.StrictMode>
        );
      }
    }
  }


})(Drupal);
